interface EditorPlaceholderProps {
  placeholder: string;
}

export default function EditorPlaceholder({ placeholder }: EditorPlaceholderProps) {
  return <div className="pointer-events-none absolute inset-0 select-none truncate text-slate-500">{placeholder}</div>;
}
